import React, { Component } from 'react';
import NoticeFacility from './noticeFacility';
import AddFacility from './addFacility';
import TextField from '@mui/material/TextField';
import FacilityBreadcrumb from './facilityBreadcrumb';
import { getUserRole } from '../../../../services/common/util';

class FacilitySearchMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                <FacilityBreadcrumb />
                <div className="row" style={{ padding: '12px' }}>
                    <div className="col-md-3">
                        <TextField
                            label="Current Grid Search"
                            variant="outlined"
                            id="reset-form"
                            InputLabelProps={{
                                shrink: true
                            }}
                            type="string"
                            margin="dense"
                            onChange={this.props.onFilterTextChange}
                        />
                    </div>
                    <div className="col-md-2">
                        <button className="btn btn-primary button-info-grid" onClick={() => this.props.clearFilter()}>
                            <i className="fa fa-times" aria-hidden="true"></i> Clear Filter
                        </button>
                    </div>
                    <div className="col-md-7" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {!/salesperson|audit|customerserviceuser|salesadmin/.test(getUserRole().toLowerCase()) && (
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <NoticeFacility facilityIds={this.props.facilityIds} />
                                <AddFacility context={this.props.context} />
                            </div>
                        )}

                        <div>
                            <button
                                className="btn btn-primary button-info-grid"
                                onClick={() => this.props.onBtnExport()}
                            >
                                <i className="fa fa-file-excel-o" aria-hidden="true"></i> Export
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FacilitySearchMenu;
